import React from "react";
import { useSortable } from "@dnd-kit/sortable";
import { CSS } from "@dnd-kit/utilities";

export function Item(props) {
    const { id, type } = props;

    const style = {
        width: "100%",
        height: 50,
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        borderRadius: 5,
        margin: "10px 0",
        background: type == "root" ? "#2185d0" : "#dadada",
        color: type == "root" ? "#fff" : "black",
        fontWeight: 700
    };

    return <div style={style}>{id}</div>;
}

export default function SortableItem(props) {
    const {
        attributes,
        listeners,
        setNodeRef,
        transform,
        transition
    } = useSortable({ id: props.id });

    const style = {
        transform: CSS.Transform.toString(transform),
        transition
    };

    return (
        <div ref={setNodeRef} style={style} {...attributes} {...listeners}>
            <Item id={props.id} type={props.type} />
        </div>
    );
}
